<template>
  <div
    id="mfaDescription" 
  >
    <v-dialog
      v-model="dialog"
      width="1000"
      persistent
      scrollable
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="blue lighten-5"
          v-on="on"
        >
          ※ワンタイムパスワード認証について
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline blue lighten-2"
          primary-title
        >
          <v-row
            dense
            max-width="100"
            align="center"
            style="margin-top:0px; padding-top:0px;"
          >
            <v-col
              cols="10"
              align="left"
              style="margin-top:0px; padding-top:0px;"
            >
              ワンタイムパスワード認証について
            </v-col>
            <v-col
              cols="2"
              align="right"
              style="margin-top:0px; padding-top:0px;"
            >
              <v-btn
                icon
                large
                color="#3F51B5"
                text
                @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-container
          id="scroll-target"
          style="max-width:1000px"
          class="overflow-y-auto"
        >
          <v-card-text>
            <v-row
              dense
              max-width="100"
            >
              <v-col
                cols="12"
              >
                <h2>
                  ワンタイムパスワード認証とは？
                </h2>
              </v-col>
              <v-col
                cols="12"
                class="ml-5"
              >
                ワンタイムパスワード認証とは一般的なID・パスワードによる本人だけが知る要素に加えて、<br>
                本人だけが持つ要素や備える要素による認証を指します。<br>
                認証要素が加わることで、一般的なID・パスワード認証よりも安全性やセキュリティが向上します。<br>
              </v-col>
              <v-col
                cols="12"
                class="mt-5"
              >
                <h2>
                  ご注意
                </h2>
              </v-col>
              <v-col
                cols="12"
                class="ml-5"
              >
                本システムではID・パスワード認証に加えて、お使いのスマートフォンで生成されるワンタイムパスワードによる認証を採用しています。<br>
                そのためスマートフォンをお使いいただけることが前提となりますことをご注意下さい。
              </v-col>
              <v-col
                cols="12"
                class="mt-5"
              >
                <h2>
                  ワンタイムパスワード認証を有効にするお客様へ
                </h2>
              </v-col>
              <v-col
                cols="12"
                class="ml-5"
              >
                ワンタイムパスワード認証の有効化はユーザー作成時または作成後でも可能です。<br>
                有効化にはお使いのスマートフォンへワンタイムパスワードを生成するためのアプリケーションのインストールが必要となります。<br>
                詳細は<a
                  href="https://faq.r4support.epson.jp/app/answers/detail/a_id/4356#q1"
                  target="_blank"
                  rel="noopener"
                >FAQ</a>をご覧ください。
              </v-col>
            </v-row>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data: () => ({
      dialog: false,
  }),
}
</script>